<script lang="ts" setup>
import { useImage } from '@/shared/composables/image'
import BKImage from '@/components/AppShared/BKImage.vue'
import { Studio } from '@/modules/Studios/types'

const { getImageById } = useImage()

interface IProps {
  studio: Studio
}

const props = defineProps<IProps>()
const srcImg = getImageById(props.studio.image, 190, 190, 'org')
</script>

<template>
  <router-link
    v-if="studio"
    :aria-label="`Link to ${studio.name}`"
    :to="{ name: 'Studio', params: { id: studio.id } }"
    class="studio-map-chip"
  >
    <img
      :src="srcImg"
      alt=""
      aria-hidden="true"
      class="background-img"
    />
    <div class="content">
      <div class="img-container">
        <BKImage
          :src="srcImg"
          alt=""
          class="studio-img"
          height="auto"
          width="85"
        />
      </div>
      <div class="data">
        <span v-if="studio.name">{{ studio.name }}</span>
        <span v-if="studio.locationAddress">{{ studio.locationAddress }}</span>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
.studio-map-chip {
  position: relative;
  width: 100%;
  min-width: 300px;
  padding: 12px;
  overflow: hidden;
  text-align: left;
  background-color: var(--color-dark-900);
  border-radius: 12px;

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    color: var(--color-white);

    .data {
      display: grid;
      gap: 4px;

      span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .event-img {
      border-radius: 6px;
    }

    .img-container {
      width: 85px;
      height: 85px;
    }
  }

  .background-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: blur(60px);
  }
}
</style>
